// Per-project color helper. Hashes the project name to a stable index in a
// fixed palette so the same project always gets the same gradient across the
// left rail, calendar, and Up Next pane.
//
// Palette is intentionally separate from the dark-cockpit theme tokens — these
// gradients are used as accents (event blocks, day markers, ranking dots),
// never as page chrome.

const palette: Array<[string, string]> = [
  ["#ff1fa5", "#ff4fcb"], // hot pink
  ["#c7a8ff", "#9c7fff"], // lavender
  ["#92f2d2", "#66e1a8"], // mint
  ["#ffd66b", "#ffb34d"], // gold
  ["#ff8aa1", "#ff5577"], // coral
  ["#ffb5da", "#ffc6e7"], // blush
];

export interface ProjectGradient {
  start: string;
  end: string;
}

export function projectGradient(name?: string | null): ProjectGradient {
  if (!name) return { start: "#8a6f86", end: "#5a2f60" }; // fallback plum-gray
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) | 0;
  const idx = Math.abs(h) % palette.length;
  return { start: palette[idx][0], end: palette[idx][1] };
}

/** CSS linear-gradient string for the project. */
export function projectGradientCss(name?: string | null, angle = 135): string {
  const g = projectGradient(name);
  return `linear-gradient(${angle}deg, ${g.start} 0%, ${g.end} 100%)`;
}
